import React from 'react';
import '../../stylesheet/components/singlecomponents/Accordion.scss';
import {ReactComponent as ChevronDown} from '../../assets/chevron.svg';

type ModalProps = {
  ExtraClass?: string;
  AccordionWrapper: string;
  AccordionCollapse: string;
  AccordionHeading: string;
  TitleHeader: string;
  ChapterType?: string;
  children: React.ReactNode;
}

const Accordion: React.FC<ModalProps> = ({ExtraClass, AccordionWrapper ,AccordionHeading, AccordionCollapse, TitleHeader, ChapterType, children}) =>  {
  return (
    <div className={`accordion-item ${ExtraClass && ExtraClass} card shadow-sm`}>
      <div className="accordion-header" id={AccordionHeading} data-bs-toggle="collapse" data-bs-target={`#${AccordionCollapse}`} aria-expanded="false" aria-controls={AccordionCollapse}>
        <div className='accordion-header__info'>
          <h5>{TitleHeader}</h5>
          {
            (ChapterType) &&
            <p className="p2 reading-time">{ChapterType}</p>
          }
        </div>
        <div className="accordion-chevron">
          <ChevronDown/>
        </div>
      </div>
      <div id={AccordionCollapse} className="accordion-collapse collapse" aria-labelledby={AccordionHeading} data-bs-parent={`#${AccordionWrapper}`}>
        <div className="accordion-body">
          {children}
        </div>
      </div>
    </div>
  )
}

export default Accordion;